import React from "react";
import SetTitle from "../../components/SetTitle";
import L1 from "../../assets/images/L1.webp";
import L2 from "../../assets/images/L2.webp";
import L3 from "../../assets/images/L3.webp";
import L4 from "../../assets/images/L4.webp";
import L5 from "../../assets/images/L5.webp";
import styles from "./LevelOfLearning.module.scss";

const LevelOfLearning = () => {
	SetTitle("Level of Learning");

	return (
		<div className={styles.LevelOfLearning}>
			<h2>Level of Learning</h2>

			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>settling batch</h3>
					<span></span>
					<div className={styles.Text}>
						<p>
							Learning to be away from family is the toughest transition for a young child. Going to preschool will
							be the first time they will be away from their parents for so long. While it is exciting for a few
							parents, it is also a nerve wrecking situation for many. To make this change easier, we have a
							specially designed settling zone where we organize interesting activities to keep the atmosphere
							upbeat for little children. We aim to create an environment that helps in building relationships
							between the children and teachers to ensure positive outcomes in all areas of learning and growth. It
							is crucial for them to feel safe, stimulated and happy just like they do at home. This zone also
							builds the trust of the parents in the preschool and how they be be partners with us for the perfect
							upbringing of their little one. The toddlers are welcomed and involved from the very beginning:
						</p>
						<p>
							Besides other facilities certain special facilities offered in the settling zone are: Play Zone,
							Creativity Corner (vegetable printing, thumb printing, etc), Clay Moulding and Cartoon Movie Shows.
						</p>
						<p>
							A teacher is allocated to each child and his/her family before he/she starts to attend the school. The
							teacher ensures that every childâ€™s care is tailored to meet their individual needs so that they can
							settle into the preschool atmosphere with ease.
						</p>
						<p>
							The parents are welcome to visit the school along with their child till he/she becomes comfortable in
							the presence of other care giving adults.
						</p>
						<p>
							The teachers share information on a regular with the parents about their childâ€™s developmental
							records and how well he/she is doing in school.
						</p>
					</div>
				</div>
				<div className={styles.Right}>
					<img src={L1} alt="" />
				</div>
			</div>

			<div className={styles.ContainerRight}>
				<div className={styles.Left}>
					<img src={L2} alt="" />
				</div>
				<div className={styles.Right}>
					<h3>play group (till 2.5 years )</h3>
					<span></span>
					<div className={styles.Text}>
						<p>
							At the age of two, children begin to develop independence and it is the best time to explore their
							developmental milestones. They begin to experiment and develop self-help skills. While each child will
							have his/her learning pace and a different way to comprehend their surroundings. With our Play Group,
							the little ones take their first step into the world of learning and growth. They are introduced to a
							more structured day with a stimulating environment that not only spreads positive energy by also makes
							learning a joyful experience. Our aim is to enrich every childâ€™s senses and enhance their
							understanding about the surroundings around them. The teachers carefully implement a dynamic learning
							system which lays emphasis on active exploration, sensory learning and introduction of new themes.
						</p>
						<p>
							This level is suitable for children in the age group between 1.8 to 2.5 years. The curriculum, group
							interactions and activities have been designed to help the child build social, emotional, language,
							cognitive and physical skills.
						</p>
						<p>
							A few activities to stimulate their development process include sensory time, story time, free-play,
							introduction to computers, celebration of festivals & events, art & craft, etc.
						</p>
						<p>
							The teachers nurture the inner strengths of each child and they also encourage the toddlers to develop
							in their own areas of interest.
						</p>
						<p>
							The parents in this level are equally encouraged to partner with the school to ensure that their ward
							is driven towards holistic development at this tender age.
						</p>
					</div>
				</div>
			</div>

			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>play group (till 2 to 3.5 years )</h3>
					<span></span>
					<div className={styles.Text}>
						<p>
							<b>Education is not learning of facts, but training the mind to think. - Albert Einstein</b>
						</p>
						<p>
							The most important priority for MINE KIDS is to lay a sound foundation for life for the little ones
							which requires quality early childhood education. For us, education will never be limited to books,
							one can learn anywhere, anytime. Nursery is a level that takes the children a step ahead in their
							educational journey. Their little minds solve small challenges which in turn build their
							problem-solving and logical reasoning skills. Their curiosity is also addressed perfectly well as
							every term brings to them a new theme and concept to unfold.
						</p>
						<p>
							This level is suitable for children in the age group between 2.5 to 3.5 years. The harmonious pace of
							growth prepares them for lifetime of learning experiences and develops in them love for creating,
							learning, discovering and exploring.
						</p>
						<p>
							The students are introduced to a monthly theme which focuses on developing academic skills such as
							pre-reading, pre-numbers, pattern writing, cognitive skills, social habits and physical strength.
						</p>
						<p>
							They also learn basic concepts like colours, shapes, moving on to understand the environment around
							them. To help them build a connect with the real world, they are indulged in imaginative play, role
							play and hands on experiences.
						</p>
						<p>
							Our vision for the students of nursery is that by the end of the session, a strong foundation is laid
							when it comes to early literacy and numeracy skills, recognising sounds letters and number and lastly
							forming healthy relationships with their parents, peers and teachers.
						</p>
					</div>
				</div>
				<div className={styles.Right}>
					<img src={L3} alt="" />
				</div>
			</div>

			<div className={styles.ContainerRight}>
				<div className={styles.Left}>
					<img src={L4} alt="" />
				</div>
				<div className={styles.Right}>
					<h3>L. K.G (3.5 to 4.5 years)</h3>
					<span></span>
					<div className={styles.Text}>
						<p>
							Learning is a self-active, experiential, problem-solving process that demands an active confrontation
							with environments, self and with others. This hands on exploration, the joy of learning and the
							strength to overcome diverse challenges are all essential foundations of the life-long learning
							process. In grade L. KG, our aim is to make the students real thinkers who taste a bit of independence
							in their own way. They can decide what they want to draw, when they want to visit the washroom and
							what to make with their toys. This sort of independence teaches them how to make the right choices.
							They are also taught how to work well within a group through listening, sharing and cooperation. Our
							caring and experienced teachers are dedicated to provide a rich and nurturing environment that will
							prepare the students to follow a formal curriculum in the coming years.
						</p>
						<p>
							This level is suitable for children in the age group between 3.5 to 4.5 years. At this level,
							subject-based learning starts for the children.
						</p>
						<p>
							Early literacy is introduced to the students through monthly themes which aim to develop the reading,
							writing and logical skills that also contribute to the achievement of developmental milestones in this
							age group. Building materials, such as blocks, support critical thinking, art & craft enhances
							creativity, outdoor play develops gross & fine motor skills, whereas, role play activities take their
							imagination to a new level.
						</p>
						<p>
							Stage exposure also comes a lot to the forefront during L. KG as the children are given ample
							opportunities to perform in front of a massive audience through fancy dress competitions or at the
							annual day.
						</p>
					</div>
				</div>
			</div>

			<div className={styles.ContainerLeft}>
				<div className={styles.Left}>
					<h3>U.K.G (4.5 to 5.5 years)</h3>
					<span></span>
					<div className={styles.Text}>
						<p>
							With the advancement in time, the millennial generation is always expected to be equipped with the
							skill of readiness. Thus, their last leg of the learning process at Mine Kids, prepares them to take
							on the world waiting ahead. As the children grow up a little, they move past the basics and are
							introduced to a well planned, structured curriculum which will act as a perfect launchpad for grade 1.
							More emphasis is laid on making academics fun for the children so that, when they enter formal school
							all their classroom anxieties remain at bay. The life skills they gain during this age make them
							balanced and responsible model citizens with perfect moral values who are also analytical enough to
							successfully deal with spontaneous situations of life.
						</p>
						<p>
							This level is suitable for children in the age group between 4.5 to 5.5 years. The child in this level
							is nurtured within the framework of a designed curriculum.
						</p>
						<p>
							The focus remains on academic progress along with the honing of life skills. The students learn how to
							construct sentences, advanced hindi and complex topics of mathematics such as before, after, in
							between).
						</p>
						<p>
							Our activities are tailored to meet the child’s individual needs, and our teachers provide
							opportunities to explore, question, communicate and create in a fun and supportive atmosphere so as to
							ensure that the students are prepared to excel at every.
						</p>
					</div>
				</div>
				<div className={styles.Right}>
					<img src={L5} alt="" />
				</div>
			</div>
		</div>
	);
};

export default LevelOfLearning;
